import { ThemeEvents } from '@theme/events';

class HolidayOrderBy extends HTMLElement {
  connectedCallback() {
    const preview = window.Shopify?.theme?.role === 'unpublished' &&
      new URLSearchParams(location.search).get('holiday_preview') === '1';
    this.hidden = this.dataset.seasonActive !== 'true' && !preview;
    this.style.display = this.hidden ? 'none' : 'block';
    if (this.dataset.context !== 'pdp') return;
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(ThemeEvents.variantUpdate, this.updateVariant);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(ThemeEvents.variantUpdate, this.updateVariant);
  }

  updateVariant = (event) => {
    if (String(event.detail.data.productId) !== this.dataset.productId) return;
    const updated = event.detail.data.html.querySelector(
      `osf-holiday-order-by[data-context="pdp"][data-product-id="${this.dataset.productId}"]`
    );
    if (updated) this.replaceWith(updated.cloneNode(true));
  };
}

if (!customElements.get('osf-holiday-order-by')) {
  customElements.define('osf-holiday-order-by', HolidayOrderBy);
}
